import { BUDGET_CONFIG } from '@/constants/questions';

interface BudgetSliderProps {
  value: number;
  onChange: (value: number) => void;
}

function formatKr(amount: number): string {
  if (amount >= 1_000_000) {
    const mio = amount / 1_000_000;
    // Vis uden decimal hvis det er et helt tal
    const formatted = mio % 1 === 0 ? mio.toFixed(0) : mio.toFixed(1);
    return `${formatted} mio. kr.`;
  }
  return new Intl.NumberFormat('da-DK').format(amount) + ' kr.';
}

export function BudgetSlider({ value, onChange }: BudgetSliderProps) {
  const { min, max, step } = BUDGET_CONFIG;
  const pct = ((value - min) / (max - min)) * 100;

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-baseline">
        <label htmlFor="budget-slider" className="text-sm font-medium text-gray-600">
          Samlet byggebudget
        </label>
        <span className="text-2xl font-serif font-semibold text-gray-900" aria-live="polite">
          {formatKr(value)}
        </span>
      </div>

      <div className="relative">
        <input
          id="budget-slider"
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          className="w-full h-2 rounded-full appearance-none cursor-pointer
            bg-gray-200 accent-brand
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
          aria-label={`Byggebudget: ${formatKr(value)}`}
          aria-valuemin={min}
          aria-valuemax={max}
          aria-valuenow={value}
          aria-valuetext={formatKr(value)}
          style={{
            background: `linear-gradient(to right, #C4511E ${pct}%, #e5e7eb ${pct}%)`,
          }}
        />
      </div>

      <div className="flex justify-between text-xs text-gray-400">
        <span>{formatKr(min)}</span>
        <span>{formatKr(max)}</span>
      </div>
    </div>
  );
}
